var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    height: 48,
    width: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.45 42.3v-4.25q-3.05-.5-4.925-2.3-1.875-1.8-2.625-4.55l3.4-1.35q.8 2.5 2.4 3.625 1.6 1.125 3.7 1.125 2.3 0 3.725-1.1 1.425-1.1 1.425-3 0-2.05-1.375-3.25Q26.8 26.05 23 24.9q-3.55-1.1-5.35-3.1-1.8-2-1.8-4.95 0-2.65 1.725-4.6Q19.3 10.3 22.45 9.9V5.7h3.3v4.2q2.3.35 4 1.625 1.7 1.275 2.6 3.375L29 16.3q-.7-1.55-1.875-2.3-1.175-.75-3.025-.75-2.15 0-3.375.925T19.5 16.75q0 1.7 1.35 2.825Q22.2 20.7 26.35 22q3.45 1.1 5.15 3.125 1.7 2.025 1.7 5.175 0 3.25-1.875 5.25T25.75 38.1v4.2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollar-icon.b3223cc016dd1a7274e1bd9da924a8df.svg";
export { ForwardRef as ReactComponent };